/*
学習パスの修了バッジ (400x400 の丸、サムネの絵柄)。パスを全部終えた人に、色の姿で出す。
終えたかは、学習パスの画面の「全体の進み」と同じ値 (済み n / 全体) だけで決める。新しい判定も DB も持たない。
絵は public/assets/path-badge に、表示の 2 倍 (192px) の webp を hash 付きで置く (1 年 immutable)
*/

/** バッジのある学習パスの id。v2 の 7 本。v1 は既定の学習パス (基本エンジニア) だけが基本の id になる */
export const PATH_BADGE_IDS = ["prep", "basic", "data-ai", "ai-dev", "fde-consult", "job", "prod-dev"] as const;
export type PathBadgeId = (typeof PATH_BADGE_IDS)[number];

export type PathBadge = { id: PathBadgeId; name: string; src: string };

export const PATH_BADGES: Readonly<Record<PathBadgeId, PathBadge>> = {
  prep: { id: "prep", name: "学習前の準備パス", src: "/assets/path-badge/prep.336f1af208.webp" },
  basic: { id: "basic", name: "基本エンジニア学習パス", src: "/assets/path-badge/basic.2d2679142e.webp" },
  "data-ai": { id: "data-ai", name: "データ分析・AIパス", src: "/assets/path-badge/data-ai.57cdca6292.webp" },
  "ai-dev": { id: "ai-dev", name: "AI駆動開発パス", src: "/assets/path-badge/ai-dev.939afcb6ba.webp" },
  "fde-consult": { id: "fde-consult", name: "FDE&ITコンサル学習パス", src: "/assets/path-badge/fde-consult.1cd8dae436.webp" },
  job: { id: "job", name: "転職活動パス", src: "/assets/path-badge/job.bf6ee1a5e3.webp" },
  "prod-dev": { id: "prod-dev", name: "実プロダクト開発演習パス", src: "/assets/path-badge/prod-dev.c41eb4e863.webp" },
};

export function isPathBadgeId(value: string | null | undefined): value is PathBadgeId {
  return value !== null && value !== undefined && (PATH_BADGE_IDS as readonly string[]).includes(value);
}

/**
 * v1 の画面 (/luagate/path) のバッジ。既定の学習パス (slug が無い) だけ基本エンジニアのバッジを出す。
 * v1 のコースの学習パス (slug 付き) には出さない。v2 のパスは hints.badgeId で渡す
 */
export function pathBadgeIdOf(courseSlug: string | null | undefined): PathBadgeId | null {
  return !courseSlug || courseSlug === "default" ? "basic" : null;
}

/** 全体の進み (済み n / 全体) から。全体が 0 のパスは終えたことにしない */
export function isPathCleared(progress: { lessonsDone: number; lessonsTotal: number } | null | undefined): boolean {
  return Boolean(progress && progress.lessonsTotal > 0 && progress.lessonsDone >= progress.lessonsTotal);
}

/** 読み上げと表示で同じ言い方にする。状態は絵ではなく字で言う */
export function pathBadgeText(name: string, cleared: boolean): { title: string; state: string; hint: string | null } {
  return cleared
    ? { title: `${name}の修了バッジ`, state: "受け取りました", hint: null }
    : { title: `${name}の修了バッジ`, state: "まだ受け取っていません", hint: "このパスを終えると受け取れます" };
}
